import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import DataActions from '../redux/dataRedux'
import MeasuresLayer from './EnergirMeasures'
import removeLayers from '../utility/removeLayers'
import { getBrand } from '../selectors/brandSelector'

const id = 'Energir'
const authId = 'Energir'
const datetimeId = 'Energir'

class MultiLayer extends Component {
  state = {
    currentTime: new Date().getTime(),
    times: [
      {
        time: new Date('2019-08-10').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-08-11/{z}/{x}/{y}.png`,
            time: new Date('2019-08-10').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-08-04/{z}/{x}/{y}.png`,
            time: new Date('2019-08-03').getTime()
          },
        }
      },
      {
        time: new Date('2019-08-03').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-08-04/{z}/{x}/{y}.png`,
            time: new Date('2019-08-03').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-07-28/{z}/{x}/{y}.png`,
            time: new Date('2019-07-27').getTime()
          },
        }
      },
      {
        time: new Date('2019-07-27').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-07-28/{z}/{x}/{y}.png`,
            time: new Date('2019-07-27').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-07-21/{z}/{x}/{y}.png`,
            time: new Date('2019-07-20').getTime()
          },
        }
      },
      {
        time: new Date('2019-07-20').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-07-21/{z}/{x}/{y}.png`,
            time: new Date('2019-07-20').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-07-14/{z}/{x}/{y}.png`,
            time: new Date('2019-07-13').getTime()
          },
        }
      },
      {
        time: new Date('2019-07-13').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/2019-07-14/{z}/{x}/{y}.png`,
            time: new Date('2019-07-13').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-07-06/{z}/{x}/{y}.png`,
            time: new Date('2019-07-06').getTime()
          },
        }
      },
      {
        time: new Date('2019-07-06').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-07-06/{z}/{x}/{y}.png`,
            time: new Date('2019-07-06').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-06-29/{z}/{x}/{y}.png`,
            time: new Date('2019-06-29').getTime()
          },
        }
      },
      {
        time: new Date('2019-06-29').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-06-29/{z}/{x}/{y}.png`,
            time: new Date('2019-06-29').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-06-22/{z}/{x}/{y}.png`,
            time: new Date('2019-06-22').getTime()
          },
        }
      },
      {
        time: new Date('2019-06-22').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-06-22/{z}/{x}/{y}.png`,
            time: new Date('2019-06-22').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/E20190616/{z}/{x}/{y}.png`,
            time: new Date('2019-06-15').getTime()
          },
        }
      },
      {
        time: new Date('2019-06-15').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/E20190616/{z}/{x}/{y}.png`,
            time: new Date('2019-06-15').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/E20190609/{z}/{x}/{y}.png`,
            time: new Date('2019-06-08').getTime()
          },
        }
      },
      {
        time: new Date('2019-06-08').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://coresight-visual-tiles.s3.ca-central-1.amazonaws.com/E20190609/{z}/{x}/{y}.png`,
            time: new Date('2019-06-08').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-06-01/{z}/{x}/{y}.png`,
            time: new Date('2019-06-01').getTime()
          },
        }
      },
      {
        time: new Date('2019-06-01').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-25/{z}/{x}/{y}.png`,
            time: new Date('2019-05-25').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-18/{z}/{x}/{y}.png`,
            time: new Date('2019-05-18').getTime()
          },
        }
      },
        {
          time: new Date('2019-05-25').getTime(),
          layers: {
            'Energir': {
              id: 'Energir',
              url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-25/{z}/{x}/{y}.png`,
              time: new Date('2019-05-25').getTime()
            },
            'Energir-base': {
              id: 'Energir-base',
              url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-18/{z}/{x}/{y}.png`,
              time: new Date('2019-05-18').getTime()
            },
          }
        },
      {
        time: new Date('2019-05-18').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-18/{z}/{x}/{y}.png`,
            time: new Date('2019-05-18').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-11/{z}/{x}/{y}.png`,
            time: new Date('2019-05-11').getTime()
          },
        }
      },
      {
        time: new Date('2019-05-11').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-11/{z}/{x}/{y}.png`,
            time: new Date('2019-05-11').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-04/{z}/{x}/{y}.png`,
            time: new Date('2019-05-04').getTime()
          },
        }
      },
      {
        time: new Date('2019-05-04').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-05-04/{z}/{x}/{y}.png`,
            time: new Date('2019-05-04').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-27/{z}/{x}/{y}.png`,
            time: new Date('2019-04-27').getTime()
          },
        }
      },
      {
        time: new Date('2019-04-27').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-27/{z}/{x}/{y}.png`,
            time: new Date('2019-04-27').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-20/{z}/{x}/{y}.png`,
            time: new Date('2019-04-20').getTime()
          },
        }
      },
      {
        time: new Date('2019-04-20').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-20/{z}/{x}/{y}.png`,
            time: new Date('2019-04-20').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-13/{z}/{x}/{y}.png`,
            time: new Date('2019-04-13').getTime()
          },
        }
      },
      {
        time: new Date('2019-04-13').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-13/{z}/{x}/{y}.png`,
            time: new Date('2019-04-13').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-06-alternate/{z}/{x}/{y}.png`,
            time: new Date('2019-04-06').getTime()
          },
        }
      },
      {
        time: new Date('2019-04-06').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-04-06/{z}/{x}/{y}.png`,
            time: new Date('2019-04-06').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-23-alternate/{z}/{x}/{y}.png`,
            time: new Date('2019-03-23').getTime()
          },
        }
      },
      {
        time: new Date('2019-03-23').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-23-alternate/{z}/{x}/{y}.png`,
            time: new Date('2019-03-23').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-16/{z}/{x}/{y}.png`,
            time: new Date('2019-03-16').getTime()
          },
        }
      },
      {
        time: new Date('2019-03-16').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-16/{z}/{x}/{y}.png`,
            time: new Date('2019-03-16').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-09/{z}/{x}/{y}.png`,
            time: new Date('2019-03-09').getTime()
          },
        }
      },
      {
        time: new Date('2019-03-09').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-09/{z}/{x}/{y}.png`,
            time: new Date('2019-03-09').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-03/{z}/{x}/{y}.png`,
            time: new Date('2019-03-03').getTime()
          },
        }
      },
      {
        time: new Date('2019-03-03').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-03-03/{z}/{x}/{y}.png`,
            time: new Date('2019-03-03').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-02-24/{z}/{x}/{y}.png`,
            time: new Date('2019-02-24').getTime()
          },
        }
      },
      {
        time: new Date('2019-02-24').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-02-24/{z}/{x}/{y}.png`,
            time: new Date('2019-02-24').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-02-17/{z}/{x}/{y}.png`,
            time: new Date('2019-02-17').getTime()
          },
        }
      },
      {
        time: new Date('2019-02-17').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-02-17/{z}/{x}/{y}.png`,
            time: new Date('2019-02-17').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/energir/2019-02-10/{z}/{x}/{y}.png`,
            time: new Date('2019-02-10').getTime()
          },
        }
      },
      {
        time: new Date('2019-02-02').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/FEB_02_cog/{z}/{x}/{y}.png`,
            time: new Date('2019-02-02').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/JAN_26_cog/{z}/{x}/{y}.png`,
            time: new Date('2019-01-26').getTime()
          },
        }
      },
      {
        time: new Date('2018-07-14').getTime(),
        layers: {
          'Energir': {
            id: 'Energir',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/JULY_14_cog/{z}/{x}/{y}.png`,
            time: new Date('2018-07-14').getTime()
          },
          'Energir-base': {
            id: 'Energir-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/JULY_07_cog/{z}/{x}/{y}.png`,
            time: new Date('2018-07-07').getTime()
        }
        }
      }
    ]
  }

  componentDidMount () {
    const { map } = this.context

    map.on('mousemove', id, this.handleMouseMove)

    window.map = map
    const ENERGIR = getBrand() === 'Energir'
    // !ENERGIR && removeLayers(map, ['parks', 'label', 'place', 'poi'])
  }

  componentWillUnmount () {
    const { map } = this.context

    map.off('mousemove', id, this.handleMouseMove)
    // map.off('load', this.handleLoad)
  }

  shouldComponentUpdate(nextProps) {
      if (nextProps.paint !== this.props.paint) {
        return false
      } else if (nextProps === this.props) {
        return false
      }
      return true
    }

  reducer = (state, action) => {
    switch (action.type) {
      case 'SET_TIME': {
        return { ...state, currentTime: action.time }
      }
    default:
      return state
    }
  }

  getLayerUrl = ({ time, id }) => {
    const { times } = this.state

    const item = times.find(item => time >= item.time)
    const url = item ? item.layers[id].url : times[times.length - 1].layers[id].url

    return url
  }



  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps(props) {
    const { paint, layout, before, layerOptions } = this.props

    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
        key === 'raster-opacity' && map.getLayer(`${id}-base`) && map.setPaintProperty(`${id}-base`, key, paintDiff[key] > 0.9 ? 0 : 1)
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  handleLoad = event => {
    console.log('load')
    console.log(event)
    // removeLayers(map, 'label')
  }
  
  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    removeLayers(map, 'label')
    if (!layerRendered) {
      return null
    }
    return null
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    const data = features.map(feature => feature.properties)
    if (data) {
      console.log(data)
      actions.dataUpdated(data[0], 'hover')
    }
  }

  render() {
    const { idToken, layerRendered, paint, time, format = 'png' } = this.props
    const { currentTime } = this.state

    if (!layerRendered) {
      return null
    }
    // const before = 'energir-network'
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : '2017-05-16T15:49:11.026Z'

    return <>
      <Source
        key={`${id}-source`}
        id={id}
        tileJsonSource={{
          type: 'raster',
          tiles: [this.getLayerUrl({ id, time: time })],
          tileSize: 512,
          scheme: 'tms',
          minzoom: 0,
          maxzoom: 15
        }}
      />
             <Source
               key={`${id}-base`}
               id={`${id}-base`}
               tileJsonSource={{
                 type: 'raster',
                 tiles: [this.getLayerUrl({ id: `${id}-base`, time: time })],
                 tileSize: 512,
                 scheme: 'tms',
                 minzoom: 0,
                 maxzoom: 15
               }}
             />
             <Layer
               key={`${id}-base-layer`}
               type='raster'
               id={`${id}-base`}
               sourceId={`${id}-base`}
               layout={{
               }}
               paint={{ 'raster-opacity': 0 }}
               before={before}
             />
      <Layer
        key={`${id}-layer`}
        type='raster'
        id={id}
        sourceId={id}
        layout={{
        }}
        paint={paint}
        before={before}
      />
             <Source
               key={`${id}-mask`}
               id={`${id}-mask`}
               tileJsonSource={{
                 type: 'vector',
                 tiles: [`https://coresight-raster.s3-us-west-2.amazonaws.com/energir-mask/{z}/{x}/{y}`],
                 tileSize: 512,
                 minzoom: 0,
                 maxzoom: 11
               }}               
             />
             <Layer
               key={`${id}-mask-layer`}
               type='line'
               id={`${id}-mask`}
               sourceId={`${id}-mask`}
               sourceLayer={`energir-mask`}
               layout={{
               }}
               paint={{'line-color': 'gray'}}
               before={before}
               onMouseMove={this.handleMouseMove}
             />
             
             <MeasuresLayer />
    </>
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = (state) => {

    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId || id] || undefined
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event)),
      pointDataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, `${id}Point`, event))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(MultiLayer)




// WEBPACK FOOTER //
// ./src/layers/Energir.js